<template>
      <v-dialog :fullscreen="$route.name == 'companyReports'"
        :content-class="`${dialog_class}`"
        v-model="viewedDocumentDialog"
        transition="scale-transition"
        @update:returnValue="onPopupClose"
        scrollable
        @keydown.esc="close()" >
        <v-card xs12 v-if="viewedDocument || ($route.name == 'press' && getDocument )">
          <v-card-title class="documentDialog_title primary">
            <v-layout row wrap >
              <v-flex xs11>
                <p v-if="$route.name == 'press'" v-text="document.title_en" />
                <p v-if="$route.name == 'companyReports'" >
                  <ais-highlight :result="viewedDocument" attribute-name="label"></ais-highlight>
                </p>
                <p v-if="$route.name == 'airportShops' || $route.name === 'seAirportShops'" v-text="viewedDocument.name" />
              </v-flex>
              <v-flex xs1 style="text-align: right;">
                <v-btn dark icon
                @click.native="close()" style="" >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text v-if="$route.name == 'press' && document.content_html_formatted_en">
            <span class='caption'>Published: <strong>{{ format(new Date(this.document.publish_date), 'yyyy-MM-dd') }}</strong></span>
            <v-alert
              v-if="document.language_original !== 'en'"
              class="mb-3"
              :value="true"
              type="warning"
            >
              This text has been translated automatically, the translation may be imperfect or misleading and we refer to the original article for unaltered information.
            </v-alert>
            <span v-bind="bin_html_formatted" v-html="document.content_html_formatted_en.replace(/\$attachment_path\//g, attachment_path)"></span>
          </v-card-text>

          <v-card-text v-if="$route.name == 'airportShops' || $route.name === 'seAirportShops'">
            <v-layout row wrap>
              <v-flex xs12 lg10 >
                <p v-bind="bin_button_visible_xs">
                  <v-btn small slot="activator" color="primary" @click.native="showChangeRequest(viewedDocument)">
                    <v-icon dark class="btn_icone">edit</v-icon> Edit
                  </v-btn>
                </p>
                <strong>Airport: </strong><span v-text="viewedDocument.airport_name"/><br />
                <strong>Geo: </strong><span v-text="viewedDocument.region"/>, <span v-text="viewedDocument.country"/>, <span v-text="viewedDocument.city"/><br />
                <span v-if="viewedDocument.last_observation_date_unix_timestamp"><strong>Last observation date: </strong>{{ format(fromUnixTime(viewedDocument.last_observation_date_unix_timestamp), 'yyyy-MM-dd') }}</span>
              </v-flex>
              <v-flex xs12 md2 >
                <v-btn v-bind="bin_button_visible_md" small slot="activator" color="primary" @click.native="showChangeRequest(viewedDocument)">
                  <v-icon dark class="btn_icone">edit</v-icon> Edit
                </v-btn>
              </v-flex>
            </v-layout>
            <div v-if="hasCommonDatas()" >
              <h4 v-if="viewedDocument.localizations && viewedDocument.localizations.length > 0">Common information:</h4>
              <span v-if="viewedDocument.url && viewedDocument.url != ''" ><strong>Useful url: </strong> <a target="_blank" :href="viewedDocument.url" ><span v-text="viewedDocument.url"/></a>
              <br /></span>
              <span v-if="viewedDocument.who_intersection && viewedDocument.who_intersection.length > 0" ><strong>Who: </strong> <span v-text="viewedDocument.who_intersection.join(', ')"/>
              <br /></span>
              <span v-if="viewedDocument.what_intersection && viewedDocument.what_intersection.length > 0" ><strong>What: </strong> <span v-text="viewedDocument.what_intersection.join(', ')"/>
              <br /></span>
              <span v-if="viewedDocument.how_intersection && viewedDocument.how_intersection.length > 0" ><strong>How: </strong> <span v-text="viewedDocument.how_intersection.join(', ')"/>
              <br /></span>
              <span v-if="viewedDocument.other_intersection && viewedDocument.other_intersection.length > 0" ><strong>Other: </strong> <span v-text="viewedDocument.other_intersection.join(', ')"/>
              <br /></span>

              <span v-show="viewedDocument.opening_hours" ><strong>Opening hours:</strong> <span v-text="viewedDocument.opening_hours"/>
              <br /></span>
              <span v-show="viewedDocument.map_url" ><strong>Map:</strong> <a target="_blank" :href="viewedDocument.map_url" ><span v-text="viewedDocument.map_url" /></a>
              <br /></span>
              <p v-show="viewedDocument.description !== undefined && viewedDocument.description">
                <br />
                <strong>Description:</strong> <br/>
                <ais-highlight :result="viewedDocument" attribute-name="description" style="word-break: break-all;"></ais-highlight>
              </p>
            </div>
            <br />
            <!-- <v-btn small disabled v-if="viewedDocument.localizations === undefined || viewedDocument.localizations.length === 0">
              Add point of sale
            </v-btn> -->
            <div v-if="viewedDocument.localizations && viewedDocument.localizations.length > 0" >
                <v-layout row wrap>
                <v-flex xs12 md10>
                  <h4 >Locations:</h4>
                </v-flex>
                <v-flex xs12 md2>

                  <!-- <v-btn small disabled>
                    Add point of sale
                  </v-btn> -->

                </v-flex>
              </v-layout>
              <v-data-iterator
                :items="viewedDocument.localizations"
                :rows-per-page-items="localization_rowsPerPageItems"
                :pagination.sync="localization_pagination"
                content-tag="v-layout"
                row
                item-key="localization_id"
                wrap
              >
                <template v-slot:item="props">
                  <v-flex xs12 sm6 md6 lg6 >
                    <v-card class="vcard_localization">
                      <v-card-title>
                        <v-layout row wrap>
                          <v-flex xs12 lg9 >
                            <h4 >{{ props.item.localization_text }}</h4>
                          </v-flex>
                          <v-flex xs12 lg3>
                            <v-btn outline
                            color="primary"
                            fab  small dark slot="activator"
                            @click.native="showChangeRequest(viewedDocument, props.item)"
                            v-bind="bin_localization_button">
                              <v-icon color="primary" >edit</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-list v-show="hasData(props.item)" dense>
                        <v-list-tile v-show="props.item.url">
                          <v-list-tile-content><a :href="props.item.url" style="word-break: break-all;" >{{ props.item.url }}</a></v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.who && props.item.who.length > 0">
                          <v-list-tile-content>Who:</v-list-tile-content>
                          <v-list-tile-content>{{ props.item.who.join(', ') }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.what && props.item.what.length > 0">
                          <v-list-tile-content>What:</v-list-tile-content>
                          <v-list-tile-content>{{ props.item.what.join(', ') }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.how && props.item.how.length > 0">
                          <v-list-tile-content>How:</v-list-tile-content>
                          <v-list-tile-content>{{ props.item.how.join(', ') }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.other && props.item.other.length > 0">
                          <v-list-tile-content>Others:</v-list-tile-content>
                          <v-list-tile-content>{{ props.item.other.join(', ') }}</v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                      <div v-show="hasData(props.item)" style="padding:0 15px 15px 15px">
                        <span v-show="props.item.description">
                          <strong>Description:</strong>
                          <p style="word-break: break-all;">{{ props.item.description }}</p>
                        </span>
                        <span v-show="props.item.note">
                          <strong>Note:</strong>
                          <p style="word-break: break-all;">{{ props.item.note }}</p>
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                </template>
              </v-data-iterator>
            </div>
            <!-- <v-img contain :src="viewedDocument.img_url" /> -->
          </v-card-text>

          <v-card-text v-if="$route.name == 'companyReports'" style="padding:0px;">
            <!-- <p style="margin:7px;"><a target="_blank" :href="viewedDocument.url">Open in new tab</a></p> -->
            <iframe :src="`${pdf_source}`"
              width="100%"
              :height="`${pdf_dialog_height}`" style="border: none;"/>
          </v-card-text>
          <v-card-actions v-if="$route.name != 'companyReports'" class="bottom_panel">
            <v-btn color="primary" flat
            @click.native="close()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
import format from 'date-fns/format'
import fromUnixTime from 'date-fns/fromUnixTime'
import { mapMutations, mapState } from 'vuex'
import DOCUMENT from '@/graphql/Document.gql'

export default {
  name: 'DocumentForm',
  props: ['displayShowDocument'],
  data () {
    return {
      document: false,
      format,
      fromUnixTime,
      attachment_path: process.env.VUE_APP_ATTACHMENT_PATH,
      expand: false,
      localization_pagination: {
        rowsPerPage: 8,
        sortBy: 'localization_text'
      },
      localization_rowsPerPageItems: [8, 16, 32]
    }
  },
  computed: {
    ...mapState('documentForm', ['viewedDocument', 'documentId', 'viewedDocumentDialog']),
    getDocument () {
      if (this.document && parseInt(this.documentId) === this.document.document_id) {
        return this.document
      }
      return false
    },
    dialog_class () {
      let classList = this.$route.name === 'companyReports' ? 'documentDialog documentDialogCompanyReport' : 'documentDialog'
      classList += this.$route.name === 'companyReports' && this.$vuetify.breakpoint.mdAndDown ? ' documentDialogCompanyReportLowerMD' : ''
      return classList
    },
    pdf_dialog_height () {
      return document.documentElement.clientHeight - 65
    },
    pdf_source () {
      if (this.$route.name !== 'companyReports') {
        return ''
      }
      let viewerSrc = process.env.VUE_APP_PDF_VIEWER_URL
      let pdfRepo = process.env.VUE_APP_PDF_REPOSITORY_URL
      let reportName = `${this.viewedDocument.reportId}.pdf`
      let page = this.viewedDocument.pageNumber
      let search = ''
      if (this.viewedDocument._highlightResult !== undefined && this.viewedDocument._highlightResult.text !== undefined && this.viewedDocument._highlightResult.text.matchedWords.length > 0) {
        search = this.viewedDocument._highlightResult.text.matchedWords.join(' ')
      }
      let src = `${viewerSrc}?file=${pdfRepo}${reportName}`
      if (this.$vuetify.breakpoint.mdAndDown) {
        src += '#zoom=80'
      } else {
        src += '#zoom=110'
      }
      if (page) { src += `&page=${page}` }
      if (search) { src += `&search=${search}` }
      return src
    },
    bin_html_formatted () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.class = 'html_formatted'
      return binding
    },
    bin_button_visible_xs () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.style = 'visibility: hidden; height: 0px;'
      return binding
    },
    bin_button_visible_md () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = 'visibility: hidden; height: 0px;'
      return binding
    },
    bin_localization_button () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) {
        binding.style = 'width: 30px!important; height: 30px!important;'
      }
      if (this.$vuetify.breakpoint.lgAndUp) {
        binding.style = 'width: 30px!important; height:30px!important ;margin-top: -7px; float: right'
      }
      return binding
    }
  },
  methods: {
    ...mapMutations('documentForm', ['setDocumentId', 'setViewedDocumentDialog']),
    ...mapMutations('locationForm', ['setViewedChangeRequest', 'setViewedChangeRequestPos', 'setViewedChangeRequestDialog']),
    async showChangeRequest (result, pos = false) {
      this.setViewedDocumentDialog(false)
      await this.setViewedChangeRequest(result)
      await this.setViewedChangeRequestPos(pos)
      this.setViewedChangeRequestDialog(true)
    },
    onPopupClose (event) {
      if (event === undefined) {
        this.close()
      }
    },
    close () {
      this.document = false
      this.setDocumentId(false)
      this.setViewedDocumentDialog(false)
      this.setViewedChangeRequestDialog(false)
    },
    hasData (item) {
      if (item.url) { return true }
      if (item.description) { return true }
      if (item.note) { return true }
      if (item.who && item.who.length > 0) { return true }
      if (item.what && item.what.length > 0) { return true }
      if (item.how && item.how.length > 0) { return true }
      if (item.other && item.other.length > 0) { return true }
      return false
    },
    hasCommonDatas () {
      if (this.viewedDocument.url && this.viewedDocument.url !== '') { return true }
      if (this.viewedDocument.opening_hours && this.viewedDocument.opening_hours !== '') { return true }
      if (this.viewedDocument.map_url && this.viewedDocument.map_url !== '') { return true }
      if (this.viewedDocument.description && this.viewedDocument.description !== '') { return true }
      if (this.viewedDocument.who_intersection && this.viewedDocument.who_intersection.length > 0) { return true }
      if (this.viewedDocument.what_intersection && this.viewedDocument.what_intersection.length > 0) { return true }
      if (this.viewedDocument.how_intersection && this.viewedDocument.how_intersection.length > 0) { return true }
      if (this.viewedDocument.other_intersection && this.viewedDocument.other_intersection.length > 0) { return true }
      return false
    }
  },
  apollo: {
    document: {
      query: DOCUMENT,
      variables () {
        return {
          id: parseInt(this.documentId)
        }
      },
      skip () {
        return this.$route.name !== 'press' || !this.documentId
      }
    }
  }
}
</script>
<style>

.documentDialog {
  margin:0px;
  width:1200px;
}
.documentDialogCompanyReport {
  left: auto!important;
}
.documentDialogCompanyReportLowerMD {
  width:100%!important;
}
.documentDialog .documentDialog_title{
  white-space: normal;
  -webkit-box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  position: relative;
  -webkit-transition: none;
  transition: none;
  width: 100%;
  will-change: padding-left,padding-right;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: .02em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0px 14px;
}
.documentDialog .documentDialog_title p {
  margin-top: 11px;
  margin-bottom: 3px;
}
.documentDialog img {
  max-width:800px;
  height:auto;
}
.documentDialog .html_formatted img {
  max-width:320px;
  height:auto;
}
.documentDialog video {
  max-width:800px;
  height:auto;
}
.documentDialog .html_formatted video {
  max-width:320px;
  height:auto;
}
.documentDialog .v-card__actions {
  box-shadow: 0 3px 14px 2px rgba(0,0,0,0.12);
}
.documentDialog  .vcard_localization{
  -webkit-box-shadow: none!important;
  box-shadow: none!important;
}

</style>
